import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import SortButton from './components/SortButton';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default function SortWidgetLayout({
  points,
  className,
  isMobile,
  buttons,
  reverseState,
  activeButtonSlug,
  sortButtonClick,
  isShown,
}) {
  return (
    isShown && (
      <div className={cx('sortWrapper', className, isMobile && 'mobile')}>
        <span className={cx('text')}>Сортировать по</span>
        {buttons.map(({ slug, ...otherProps }) => (
          <SortButton
            key={`${slug}_button`}
            isMobile={isMobile}
            slug={slug}
            points={points}
            onClick={sortButtonClick}
            isReverse={reverseState}
            isActive={slug === activeButtonSlug}
            {...otherProps}
          />
        ))}
      </div>
    )
  );
}

SortWidgetLayout.propTypes = {
  points: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      address: PropTypes.string,
      opening: PropTypes.string,
      availableDate: PropTypes.string,
      subway: PropTypes.shape({
        name: PropTypes.string,
        color: PropTypes.string,
      }),
    }),
  ),
  className: PropTypes.string,
  isMobile: PropTypes.bool,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string,
      sortBy: PropTypes.string,
      reverseMode: PropTypes.bool,
      reverseText: PropTypes.string,
      buttonText: PropTypes.string,
    }),
  ),
  reverseState: PropTypes.bool,
  activeButtonSlug: PropTypes.string,
  sortButtonClick: PropTypes.func,
  isShown: PropTypes.bool,
};
